import { Button } from "@msuite/ui/button";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";

export function ProcessSubstitutionExpired() {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Button
			className="w-[200px] h-stack justify-start pointer-events-none"
			icon={
				<Icon
					className="stroke-red-500 fill-red-500/20"
					name="Ban"
				/>
			}
			onClick={() => {}}
			variant="ghost"
		>
			{t("substitutions.is_expired")}
		</Button>
	);
}
